/**
 * +-------------------------------------------------+
 * |                                                 |
 * | Function Global Untuk Pagination dan get Data   |
 * +_________________________________________________+
 * 
 * Asalkan function mixin dan vue componentnya sama pagination bisa berjalan
 */

export const PaginationRekomendasi = {
    data() {
      return {
        items: [],
        indexed: '',
        searchDokumenRekomendasi: '',
        formFilter : {
            idRekomendasi : '',
        },
        search : "",
        idRekomendasi : "",
        pageSize : "10",
        currentPage :0,
        timeout: 0,
        pagination: {
            totalPages: 0
        },
        no: 1,
      };
    },
    watch: {
        search: function (val) {
            if(val != "") {
                clearTimeout(this.timeout);
                var vm = this
                this.timeout = setTimeout(function () {
                    // enter this block of code after 1 second
                    // handle stuff, call search API etc.
                    var searchVar = vm.search.trimStart();
                    var searchFinal = searchVar.trimEnd();
    
                    vm.getData("0", vm.pageSize, searchFinal, 'default');
                }, 1000);
            } else {
                this.getData("0", this.pageSize, 'default', this.formFilter.idRekomendasi);
            }
        },
        
        searchDokumenRekomendasi: function (val) {
            if(val != "") {
                clearTimeout(this.timeout);
                var vm = this
                this.timeout = setTimeout(function () {
                    // enter this block of code after 1 second
                    // handle stuff, call search API etc.
                    var searchVar = vm.searchDokumenRekomendasi.trimStart();
                    var searchFinal = searchVar.trimEnd();
                    // // comment console console.log()
                    vm.getData("0", vm.pageSize, searchFinal,vm.formFilter.idRekomendasi);
                }, 1000);
            } else {
                this.getData("0", this.pageSize, 'default', this.formFilter.idRekomendasi);
            }
        },
     
        /**
         * 
         * End Data Peserta Sertifikasi RPl 
         */
        currentPage: function(val) {
            //alert val -1 
            var page = val - 1;
            this.indexed = page * 10;
            if(this.idTc != null || this.idTc != undefined) {
                this.getData(this.idTc,val - 1, this.pageSize, this.search, this.formFilter.idRekomendasi);
                
            } else {

                this.getData(val - 1, this.pageSize, this.search, this.formFilter.idRekomendasi);
            }
        }
    },
    methods: {
        /**
         * 
         * Data Peserta Sertifikasi  
         */
       
        ltrim(str) {
            if(!str) return str;
            return str.replace(/^\s+/g, '');
        },
        changePageSize(e) {
            // comment console console.log(e.target.value);
            var pageSize = "";
            var vm = this;
            if (e.target.value == "Semua Data") {
                pageSize = "50000";
                this.pageSize = pageSize;
            } else {
                pageSize = e.target.value;
                this.pageSize = pageSize;
            }

            this.getData("0", vm.pageSize, vm.search,vm.formFilter.idRekomendasi);
        },
    }
  };